/*
Componente para mostrar información temporal
*/

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// CSS
import styles from './Snackbar.css'
import styled from 'styled-components'

export default function Snackbar({ show, setShow, message }) {
  const [showSnackbar, setShowSnackbar] = useState('')

  const Div = styled.div`
    visibility: hidden;
    min-width: 250px;
    margin-left: -125px;
    background-color: #333;
    color: #fff;
    text-align: center;
    border-radius: 20px;
    padding: 16px;
    position: fixed;
    z-index: 100;
    left: 50%;
    bottom: 50%;
  `

  useEffect(() => {
    if (show) {
      setShowSnackbar(styles.show)
      setTimeout(() => {
        setShowSnackbar('')
        setShow(false)
      }, 3000)
    }
  }, [show, setShow])

  return (
    <Div id='snackbar' className={showSnackbar} data-lang={message}>
      {message}
    </Div>
  )
}

Snackbar.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
}
